import React from 'react'

export interface CartDescription {
  productName: string
  productImage: string
  productTotal: string | number
  productCount?: string | number | null
  productPatient?: string | null
}

export interface CartContextValue {
  updateCart(data: CartDescription): void
  setAnchorEl(el: HTMLElement): void
}

const CartContext = React.createContext<CartContextValue | null>(null)

export default CartContext
